import type { AnswerInputProps } from '../QuestionRenderer'

export function OpinionScaleInput({
  question,
  value,
  onChange,
  onSubmit,
}: AnswerInputProps<number>) {
  const steps = Number(question.settings.steps ?? 5)
  return (
    <div>
      <div
        className="grid w-full"
        style={{
          gap: 'var(--form-answer-gap,0.875rem)',
          gridTemplateColumns: `repeat(${steps}, minmax(0, 1fr))`,
        }}
      >
        {Array.from({ length: steps }, (_, index) => index + 1).map((score) => (
          <button
            key={score}
            type="button"
            onClick={() => {
              onChange(score)
              window.setTimeout(onSubmit, 120)
            }}
            className={`grid min-h-12 w-full place-items-center rounded-md border px-2 font-semibold ${
              value === score ? 'border-[var(--form-accent,#6366F1)]' : 'border-slate-200'
            }`}
            style={{
              background:
                value === score
                  ? 'var(--form-accent,#6366F1)'
                  : 'color-mix(in srgb, var(--form-bg,#F8FAFC) 86%, white)',
              borderColor:
                value === score
                  ? 'var(--form-accent,#6366F1)'
                  : 'color-mix(in srgb, var(--form-accent,#6366F1) 24%, transparent)',
              borderRadius: 'var(--form-radius,8px)',
              color:
                value === score ? 'var(--form-button-text,#FFFFFF)' : 'var(--form-answer,#334155)',
              fontFamily: 'var(--form-body-font,var(--form-font,Geist))',
              fontSize: 'var(--form-body-size,1.125rem)',
            }}
          >
            {score}
          </button>
        ))}
      </div>
      <div
        className="mt-3 flex justify-between gap-4 text-sm"
        style={{
          color: 'var(--form-answer,#64748B)',
          fontFamily: 'var(--form-body-font,var(--form-font,Geist))',
          fontSize: 'var(--form-meta-size,0.9375rem)',
        }}
      >
        <span>{question.settings.startLabel}</span>
        <span>{question.settings.endLabel}</span>
      </div>
    </div>
  )
}
